exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._19OGYfIPi2ZzNhF84ED_PX{font-size:13px;line-height:15px;width:202px}._19OGYfIPi2ZzNhF84ED_PX h4{font-size:14px;font-weight:500}._19OGYfIPi2ZzNhF84ED_PX p{margin-bottom:5px;overflow-wrap:break-word}._1Q_RPvEhuPX_lGr_mgQ365{margin:5px -5px 0 0;font-size:0;line-height:0}._1Q_RPvEhuPX_lGr_mgQ365 img{height:64px;width:64px;background:#e0e0e0;margin:5px 5px 0 0;display:inline-block;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"poiPopup": "_19OGYfIPi2ZzNhF84ED_PX",
	"Photogrid": "_1Q_RPvEhuPX_lGr_mgQ365"
};